module.exports = __webpack_public_path__ + "fonts/SpaceMono-Italic.ttf";